export default __webpack_public_path__ + "static/media/slide-2.47823077.png";